module.exports = __webpack_public_path__ + "static/media/meditation-erstellen-pic.371748b5.jpg";